import api from '../../../services/Api';
import { IAuditoriaRastreabilidadeBancariaResultado } from '../interfaces/IAuditoriaRastreabilidadeBancaria';

export type ModoValidacaoRastreabilidade = 'RsEDoc' | 'RsOuDoc' | 'SomenteRs' | 'SomenteDoc';

export const AuditoriaRastreabilidadeBancariaService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
    modoValidacao?: ModoValidacaoRastreabilidade;
    contasExcluidas?: string[];
    // COR-238: obrigatória (validada no backend) quando modoValidacao reduz a exigência documental
    // padrão — gravada na trilha de auditoria (audit_log).
    justificativa?: string;
  }): Promise<IAuditoriaRastreabilidadeBancariaResultado> {
    const queryParams: Record<string, string> = {
      empresaIds: String(params.empresaId),
      periodo: params.periodo || '',
    };

    if (params.modoValidacao && params.modoValidacao !== 'RsEDoc')
      queryParams.modoValidacao = params.modoValidacao;

    if (params.contasExcluidas && params.contasExcluidas.length > 0)
      queryParams.contasExcluidas = params.contasExcluidas.join(',');

    if (params.justificativa && params.justificativa.trim())
      queryParams.justificativa = params.justificativa.trim();

    const response = await api.get<IAuditoriaRastreabilidadeBancariaResultado>('auditoria-rastreabilidade-bancaria/resultado', {
      params: queryParams,
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        fundamentacaoFiscal: '',
        errosRastreabilidade: [],
        contasConciliadas: [],
        divergenciasReferencial: [],
        parametrosAplicados: {
          modoValidacao: 'RsEDoc',
          descricaoModo: 'Participante Identificado e Número de Documento obrigatórios (padrão IN RFB nº 2.003/2021)',
          contasExcluidas: [],
          configuracaoPersonalizada: false,
          participanteExigido: true,
          documentoExigido: true,
        },
      }
    );
  },
};
